export interface SurveyResponseLoop {
  loopId: string;
  configurationId: string;
  sourceId: string;
  sourceIndex: number;
  sourceName: string;
  allocationPosition: number | null;
}
